import { render, staticRenderFns } from "./PlayerQuiz.vue?vue&type=template&id=24b9d20e&scoped=true&"
import script from "./PlayerQuiz.vue?vue&type=script&lang=js&"
export * from "./PlayerQuiz.vue?vue&type=script&lang=js&"
import style0 from "./PlayerQuiz.vue?vue&type=style&index=0&id=24b9d20e&scoped=true&lang=scss&"
import style1 from "./PlayerQuiz.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9d20e",
  null
  
)

export default component.exports